import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, Type } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ProductPurchase } from '../../../interfaces/product.model';
import { AddToCartDialog } from '../add-to-cart-dialog/add-to-cart-dialog';
import { PriceBelowMinimumWarning } from '../price-below-minimum-warning/price-below-minimum-warning';
import { PurchaseHistory } from '../purchase-history/purchase-history';

// «Aggiungi al carrello» con l'ultima vendita del prodotto al cliente e lo storico: «Applica» copia quantita' e prezzo,
// che restano modificabili. Senza ultimo acquisto e' identico al dialog che estende.
@Component({
  providers: [provideTranslocoScope('products')],
  selector: 'prd-add-to-cart-purchase-history-dialog',
  imports: [
    TranslocoPipe,
    NgComponentOutlet,
    MatDialogModule,
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    PriceBelowMinimumWarning,
  ],
  templateUrl: '../add-to-cart-dialog/add-to-cart-dialog.html',
  styleUrl: '../add-to-cart-dialog/add-to-cart-dialog.scss',
})
export class AddToCartPurchaseHistoryDialog extends AddToCartDialog {
  private readonly applyPurchase = (purchase: ProductPurchase) => {
    if ((purchase.quantita ?? 0) > 0) {
      this.quantity.set(Math.round(purchase.quantita!));
    }
    if (purchase.prezzo != null) {
      this.price.set(purchase.prezzo);
    }
  };

  protected override extra(): Type<unknown> | null {
    return this.data.ultimoAcquisto ? PurchaseHistory : null;
  }

  protected override extraInputs(): Record<string, unknown> {
    return { purchase: this.data.ultimoAcquisto, unit: this.data.unitaMisura, apply: this.applyPurchase };
  }
}
